// extracted by mini-css-extract-plugin
export default {"checkboxBlock":"input-checkbox_checkboxBlock__rhOUN"};